(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-compare"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('.before-after-slider-section .containered');

  containers.forEach((container) => {
    const slider = container.querySelector('.slider');
    slider.addEventListener('input', (e) => {
      container.style.setProperty('--position', `${e.target.value}%`);
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
